import React, { useContext, useRef } from 'react';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import { useQuery, useMutation } from '@apollo/client';
import { 
  GET_BOOK_DATA, 
} from '@graphql/editor';

import NextIcon from '@icons/editor/next-icon';

import { 
  Wrapper, 
  StyledHeader, 
  BtnBlock, 
  CloseBtn, 
  StyledBody, 
  DocCard, 
  DocItem,
  DocItemLink,
  IconBlock, 
  TextBlock,
  Text,
  StyledBodyLoad
} from './editor-comment.styles';

const EditorSource = ({ id, value }) => {
  const [state, dispatch] = useContext(Context);
  const wrapperRef = useRef(null);


  return (
    <div
      style={{ display: state.isEditorSourceSidebarOpened ? 'block' : 'none' }}
      data-is-opened={state.isEditorSourceSidebarOpened}
      ref={wrapperRef}
    >
      <Wrapper>
        <StyledHeader>
          Использованная литература
          <BtnBlock>
            <CloseBtn title="Вернуться обратно" data-ignore-click-outside="sidebar" onClick={() => {
              dispatch({ type: 'TOGGLE_EDITOR_SOURCE_MODAL' });
            }}>
              <NextIcon/>
            </CloseBtn>
          </BtnBlock>
        </StyledHeader>
        <StyledBody>
        {value.map(item => (
            <>
              <SourceList id={id} item={item}/>
            </>
        ))}
        </StyledBody>
      </Wrapper>
    </div>
  );
};

const SourceList = ({ id, item }) => {
  const { loading, error, data, refetch } = useQuery(GET_BOOK_DATA, { variables: { id: item } });
  if (loading)
    return (
      <StyledBodyLoad>
        <p>Загрузка</p>
      </StyledBodyLoad>
    );
  const url = 'https://e.nlrs.ru/online3/'+data.book.id;
  return (
    <DocCard> 
      {data.book.id == id ? 
        <DocItem>
          <TextBlock>
            <Text className="content" dangerouslySetInnerHTML={{__html: data.book.shortBibl}}></Text>
          </TextBlock>
        </DocItem>
      :
        <DocItemLink href={data.book.id == id ? null : url} target="_blank">
          <TextBlock>
            <Text className="content" dangerouslySetInnerHTML={{__html: data.book.shortBibl}}></Text>
          </TextBlock>
        </DocItemLink>
      }
    </DocCard>
  );
};

export default EditorSource;
